import { useEffect } from 'react'
import AuthLogic from '../../functions/logic/Auth'

const useRefreshToken = () => {
  const refreshToken = async () => {
    try {
      await AuthLogic.refreshTokenLogic()
    } catch (error) {
      console.error('Error refreshing token', error)
    }
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      refreshToken()
      const interval = setInterval(() => {
        refreshToken()
      }, 14 * 60 * 1000)

      return () => clearInterval(interval)
    }, 14 * 60 * 1000)

    return () => clearTimeout(timeout)
  }, [])
}

export default useRefreshToken
